import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { OfficeHoursMessage } from '@backrs_ui/grow-ui/src/models/models';

const REPORT_REQUEST = appStrings.modules.satActBooster.nav.reportSeamPrompt;

/** Newest report request at or past `floor`, or -1. A score edit queues a second one; the first is stale. */
export const findReportRequestIndex = (messages: OfficeHoursMessage[], floor = 0): number =>
  messages.reduce(
    (latest, message, index) =>
      index >= floor && message.sender === 'user' && message.text === REPORT_REQUEST
        ? index
        : latest,
    -1,
  );

/** Newest user turn, or -1. Prompt-button turns count. */
export const findLastUserIndex = (messages: OfficeHoursMessage[]): number =>
  messages.reduce((latest, message, index) => (message.sender === 'user' ? index : latest), -1);
